export const categories = [
  {
    id: 'all',
    name: '全部话题',
    icon: 'ri-apps-2-line',
    desc: '覆盖站内所有正在讨论的内容方向',
    count: 128,
  },
  {
    id: 'ent',
    name: '娱乐爆料',
    icon: 'ri-movie-2-line',
    desc: '影视综动态、艺人行程与幕后消息',
    count: 36,
  },
  {
    id: 'tech',
    name: '科技数码',
    icon: 'ri-cpu-line',
    desc: '新品情报、行业动向与产品实测讨论',
    count: 24,
  },
  {
    id: 'finance',
    name: '财经观察',
    icon: 'ri-line-chart-line',
    desc: '市场变化、公司动态与消费趋势',
    count: 19,
  },
  {
    id: 'society',
    name: '社会热点',
    icon: 'ri-earth-line',
    desc: '公共事件、城市生活与民生话题',
    count: 27,
  },
  {
    id: 'life',
    name: '生活消费',
    icon: 'ri-shopping-bag-3-line',
    desc: '消费体验、避坑经验与实用测评',
    count: 14,
  },
  {
    id: 'sports',
    name: '体育赛事',
    icon: 'ri-basketball-line',
    desc: '赛程战报、转会传闻与赛场内外',
    count: 8,
  },
];